import React from "react";
import { Link } from "react-router-dom";

const ServiceAreaOneMultiImg = () => {
  const services = [
    {
      id: 1,
      name: "Mobile tyre fitting service",
      icon: "service-icon-1.svg",
    },
    {
      id: 2,
      name: "MOT's",
      icon: "service-icon-2.svg",
    },
    {
      id: 3,
      name: "Services",
      icon: "service-icon-3.svg",
    },
    {
      id: 6,
      name: "Battery service",
      icon: "service-icon-6.svg",
    },
    {
      id: 7,
      name: "Brake service",
      icon: "service-icon-7.svg",
    },
    {
      id: 11,
      name: "Engine Diagnostics",
      icon: "service-icon-11.svg",
    },
    {
      id: 12,
      name: "Clutches",
      icon: "service-icon-12.svg",
    },
    {
      id: 13,
      name: "Exhausts Service",
      icon: "service-icon-13.svg",
    },
    {
      id: 14,
      name: "Suspension",
      icon: "service-icon-14.svg",
    },
    {
      id: 15,
      name: "Cambelts",
      icon: "service-icon-15.svg",
    },
    {
      id: 17,
      name: "Summer Check",
      icon: "service-icon-17.svg",
    },
  ];

  return (
    <div className="service-area-1 space overflow-hidden">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6">
            <div className="title-area text-center">
              <span className="sub-title">What We Offer</span>
              <h2 className="sec-title">
                Your One-Stop Auto Service Center
                <img
                  className="title-bg-shape shape-center"
                  src="assets/img/bg/title-bg-shape.png"
                  alt="Silverline"
                />
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row gy-4 justify-content-center">
          {services.map((item, index) => {
            return (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="service-card text-center">
                  <div className="service-card_content">
                    <div className="service-card_icon">
                      <img
                        src={`assets/img/icon/${item.icon}`}
                        alt={item.name}
                        width={100}
                      />
                    </div>
                    <h4 className="text-white h5">
                      <Link to={`/select-service/${item.name}`}>
                        <h4 className="text-white">{item.name}</h4>
                      </Link>
                    </h4>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaOneMultiImg;
